export const storeImportFile = async (file, type) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', type);

        const { data } = await axios.post('/import-history/store-file', formData);

        if (data.status === 'error') {
            return null;
        }

        if (data.status === 'success') {
            return data.file_path;
        }
    } catch (error) {
        console.error('File upload error:', error);

        return null;
    }
}

export const storeImportHistory = async (layoutId, filePath, type, savedMapping) => {
    try {
        const { data } = await axios.post('/import-history/store-import-history', {
            'layout_id': layoutId,
            'file_path': filePath,
            'type': type,
            'saved_mapping': savedMapping
        });

        if (data.status === 'error') {
            return null;
        }

        return data.import_history;
    } catch (error) {
        console.log('Error storing import history:', error);

        return null;
    }
}

export const fetchImportFile = async (filePath) => {
    try {
        const response = await axios.get('/import-history/download-file', {
            params: { file_path: filePath },
            responseType: 'blob',
        });

        const fileName = filePath.split('/').pop();
        const file = new File([response.data], fileName, {
            type: response.headers['content-type'] || 'application/octet-stream',
        });

        return file;
    } catch (error) {
        console.log('Error fetching file:', error);

        return null;
    }
}

export const getGtinSettings = () => {
    // todo get gtin settings
}

export const getFeedSettings = () => {
    // todo get feed settings
}